/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StoreAggregatorOnboardingGetResponse } from '../../models/store-aggregator-onboarding-get-response';

export interface StoreAggregatorOnboarding$Params {
  'Active-Tenant-Identifier': string;
  storeId: string;
}

export function storeAggregatorOnboarding(http: HttpClient, rootUrl: string, params: StoreAggregatorOnboarding$Params, context?: HttpContext): Observable<StrictHttpResponse<StoreAggregatorOnboardingGetResponse>> {
  const rb = new RequestBuilder(rootUrl, storeAggregatorOnboarding.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('storeId', params.storeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StoreAggregatorOnboardingGetResponse>;
    })
  );
}

storeAggregatorOnboarding.PATH = '/stores/{storeId}/onboarding';
